// ##############################
// // // Header styles
// #############################

import {
  containerFluid,
  defaultFont,
  appBoxShadow,
  colors
} from "../views/material-dashboard-pro-react.jsx";

const headerStyle = theme => ({
  appBar: {
    backgroundColor: "transparent",
    boxShadow: "none",
    borderBottom: "0",
    marginBottom: "0",
    position: "absolute",
    width: "100%",
    paddingTop: "10px",
    zIndex: "1029",
    color: "#555555",
    border: "0",
    borderRadius: "3px",
    padding: "10px 0",
    transition: "all 150ms ease 0s",
    minHeight: "50px",
    display: "block"
  },
  container: {
    ...containerFluid,
    minHeight: "50px"
  },
  flex: {
    flex: 1
  },
  title: {
    ...defaultFont,
    lineHeight: "30px",
    fontSize: "18px",
    borderRadius: "3px",
    textTransform: "none",
    color: "inherit",
    paddingTop: "0.625rem",
    paddingBottom: "0.625rem",
    "&:hover,&:focus": {
      background: "transparent"
    }
  },
  primary: {
    backgroundColor: colors.primaryColor,
    color: "#FFFFFF",
    boxShadow: appBoxShadow.defaultBoxShadow
  },
  info: {
    backgroundColor: colors.infoColor,
    color: "#FFFFFF",
    boxShadow: appBoxShadow.defaultBoxShadow
  },
  success: {
    backgroundColor: colors.successColor,
    color: "#FFFFFF",
    boxShadow: appBoxShadow.defaultBoxShadow
  },
  warning: {
    backgroundColor: colors.warningColor,
    color: "#FFFFFF",
    boxShadow: appBoxShadow.defaultBoxShadow
  },
  danger: {
    backgroundColor: colors.dangerColor,
    color: "#FFFFFF",
    boxShadow: appBoxShadow.defaultBoxShadow
  },
  sidebarMinimize: {
    float: "left",
    padding: "0 0 0 15px",
    display: "block",
    color: "#555555"
  },
  sidebarMinimizeRTL: {
    padding: "0 15px 0 0 !important"
  },
  sidebarMiniIcon: {
    width: "20px",
    height: "17px"
  }
});

export default headerStyle;
